import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useConselhosState } from "../context/conselhos-context";
import { useConselhosController } from "../context/conselhos-controller";
import { ConselhoForm } from "./conselho-form";

export const ConselhoDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useConselhosController();
    const { dataResponse, showAddEdit } = useConselhosState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Conselho ${dataResponse?.id}`;
        return "Adicionar Conselho";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <ConselhoForm />
        </DefaultDrawer>
    );
};
